import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-exercise-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css'],
})

export class ItemComponent implements OnInit, AfterViewInit {
  @Input() lpmapcId: number;
  @Input() uploadDisabled: boolean;
  @Input() exerciseType: number;
  @Input() question: any;
  @Input() questionNo: number;
  @Input() page: string;
  @Input() myComment: string; //是否有顾问点评
  @Input() collapse: boolean; //是否收拢两行
  @Input() relationId: number;
  @Input() tabNum: number = 0;
  @Input() isLastDay: boolean;
  @Input() isFirstDay: boolean;
  @Input() questions: any;
  @Input() pdfList: any;
  @Input() uploadList: any;
  @Input() text : string;
  @Input() myData : any;
  @Input() studentList: any;
  @Input() questionGroupLength : any;
  @Input() isSave : number;
  @Input() checkElse : boolean = false;
  @Input() terminalType : number;//1:pc 2：移动
  @Output() outPutDownload = new EventEmitter<any>();
  @Output() outPutData = new EventEmitter<any>();
  @Output() outPutFileLoad = new EventEmitter<any>();
  @Output() outPutDelFile = new EventEmitter<any>();
  @Output() outPutCanSave = new EventEmitter<any>();
  @Output() outPutPreview = new EventEmitter<any>();
  @Output() outGetNextBtn = new EventEmitter<any>();
  assetsRoute: string = '../../../assets';
  stepGroup: any;
  checkBoxData: string;
  disabledAdd: boolean = false;
  disabledUpload: boolean = false;
  answersCopy: any;
  stepGroupCopy: any;
  isShowAnalysis: boolean = false; //是否显示实时答案
  analysis: string;
  singleCurrentId:number = 0;//单选题选择的optionid
  multipleAnswers:string = "";//多选题正确答案optionid
  showViewAnswerBtn : boolean = true;//是否展示查看答案按钮
  disableAnswerBtn : boolean = true;//是否禁查看答案用按钮
  isShowToast : boolean = false;
  destext : string = "";
  imgList : any[]//类型为7的图片数组
  campId : number = 0;
  pcUrl:string = 'https://m.transtalent.cn/pc/applytask';//day14提示去pc链接
  toastTip:string="";
  intelligentTitleType:any = ["文本题","单选题","表格题","多选题","附件题","表格题","文本题","表格题"];
  campTitleType:any = ["文本题","单选题","表格题","多选题","附件题","表格题","文本题","表格题"];
  constructor() {
  }

  ngOnInit() {
    this.pcUrl = window.location.hostname === 'm.transtalent.cn'? 'https://m.transtalent.cn/pc/applytask':'https://m-uat.transtalent.cn/pc/applytask';
    this.campId = Number(localStorage.getItem('campId'));
    this.initTypeData();
  }

  ngAfterViewInit() {
    if(this.question['type'] === 6){//表格题时判断是否要禁止输入
      this.textareaAutoHeight();
      if(this.question.disable == 0){
        $(".table-textarea").attr("disabled",true)
      }else{
        $(".table-textarea").attr("disabled",false)
      }
    }
  }

  initTypeData(){
    if (this.question['type'] === 3 || this.question['type'] === 6 || this.question['type'] === 8) {
      this.stepGroup = this.question['tableData'].length > 0 ? this.question['tableData'] : [[]];
      while (typeof (this.stepGroup) !== 'object') {
        this.stepGroup = JSON.parse(this.stepGroup);
      }
      this.stepGroupCopy = this.stepGroup;
    }else if (this.question['type'] === 2 && !this.isLastDay){
      this.isShowAnalysis = this.question.options.filter(item => item['select']).length > 0;
      this.singleCurrentId = this.isShowAnalysis ? this.question.options.filter(item => item['select'])[0].optionId : 0;
      if(this.isShowAnalysis){
        this.analysis = this.question.options.filter(item => item['select'])[0]['analysis'];
      }
    }else if(this.question['type'] === 4 && !this.isFirstDay && !this.isLastDay && this.page == 'answer'){
      this.question['options'].forEach(item=>{
        if(item.correct){
          this.multipleAnswers += item.optionId + "|";
        }
      })
      if(this.question.options.some(item=>item.select) && this.question['options'].filter(item=>item.select).length>=2){
        this.judgeMulSelect();
      }
    }

    if(this.question['type'] === 7 && this.page == "answer" && JSON.parse(this.question.extendText)){
      this.imgList = JSON.parse(this.question.extendText);
    }
  }

  /**
   * 添加一个步骤
   * @param id: Number   问题Id
   */
  addStep(id: number): void {
    if (this.stepGroup.length === 9) {
      this.disabledAdd = true;
    }
    //跳转到对应位置
    let ele = document.querySelector(`.add-step`);
    setTimeout(() => {
      ele.scrollIntoView();
    }, 100);
    this.outPutCanSave.emit(true);
    if (this.stepGroup.length < 10) {
      this.stepGroup.push(['', '']);
      if (this.stepGroup) {
        this.outPutData.emit({
          'constituteId': this.lpmapcId,
          'questionId': id,
          'tableData': this.stepGroup,
          'type': 3
        });
      } else {
        this.outPutData.emit({
          'constituteId': this.lpmapcId,
          'questionId': id,
          'type': 3
        });
      }
    } else {
      return;
    }
  }

  //删除一个步骤
  minusStep(index: number, id: number): void {
    this.disabledAdd = false;
    this.outPutCanSave.emit(true);
    this.stepGroup.splice(index, 1);
    if (this.stepGroup) {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'tableData': this.stepGroup,
        'type': 3
      });
    } else {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'type': 3
      });
    }
  }

  //获取单选题答案
  getRadioAnswer(answers): string {
    if(this.isLastDay && this.tabNum == 1){
      return this.question['answers'];
    }else{
      //为了处理训练营第一道题是多选题但type为2的历史数据
      if(answers.indexOf("|") !== -1){
        let answersArr = answers.split("|");
        let newAnswerArr = "";
        answersArr.forEach(item=>{
          if(item){
            let index = this.question['options'].findIndex((v) => v['optionId'] === Number(item));
            newAnswerArr += this.question['options'][index]['context'] +"<br>";
          }
        })
        return newAnswerArr;
      }else{
        let index = this.question['options'].findIndex((v) => v['optionId'] === Number(answers));
        return this.question['options'][index]['context'];
      }
    }
  }

  //步骤题
  stepBlur(id: number, stepGroupIdx: number): void {
    this.outPutCanSave.emit(true);
    this.stepGroup[stepGroupIdx][0] = $('.input-' + id).eq(stepGroupIdx).val() ? $('.input-' + id).eq(stepGroupIdx).val() : '';
    this.stepGroup[stepGroupIdx][1] = this.stepGroup[stepGroupIdx][1] ? this.stepGroup[stepGroupIdx][1] : '';
    if (this.stepGroup) {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'tableData': this.stepGroup,
        'type': 3
      });
    } else {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'type': 3
      });
    }
  }

  adjustHeight(textareaElement, minHeight){
    // 设置高度为0以防需要收缩（高度）
    textareaElement.style.height = 0;
    // 设置正确的高度
    // el.scrollHeight 是文本内容的全部高度，而不仅仅是可见部分的。
    textareaElement.style.height = Math.max(minHeight, textareaElement.scrollHeight) + 'px';
  }

  textareaAutoHeight(){
    let textarea = document.querySelectorAll('.table-textarea');
    for(let i = 0;i<textarea.length;i++){
      let el = textarea[i];
      let minHeight = el.scrollHeight;
      let that = this;
      el.addEventListener('input', function(e) {
        that.adjustHeight(this, minHeight);
      });
      // 我们调整初始内容的高度
      this.adjustHeight(el, minHeight);
    }
  }

  //表格题
  tableBlur(id: number, stepGroupIdx: number): void {
    this.outPutCanSave.emit(true);
    // this.stepGroup[stepGroupIdx][0] = $('.input-' + id).eq(stepGroupIdx).val() ? $('.input-' + id).eq(stepGroupIdx).val() : '';
    this.stepGroup[stepGroupIdx][0] = $('.textarea-' + id).eq(stepGroupIdx).val() ? $('.textarea-' + id).eq(stepGroupIdx).val() : '';
    this.stepGroup[stepGroupIdx][1] = this.stepGroup[stepGroupIdx][1] ? this.stepGroup[stepGroupIdx][1] : '';
    if (this.stepGroup) {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'tableData': this.stepGroup,
        'type': 6
      });
    } else {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'type': 6
      });
    }
  }

  /**
   * 预览
   * @param url:  String     预览文件的地址
   * @param type: Number     预览文件的类型
   */
  showPreview(url:string,type:number):void{
    this.outPutPreview.emit({'fileUrl':url,'fileType':type});
  }

  /**
   * 单选题选中
   * @param id: Number     题目Id
   * @param index: Number  题目下标
   * @param optId: Number  选项Id
   */
  optSelected(id: number, index: number, optId: number,correct:number,analysis:string): void {
    this.singleCurrentId = optId;
    this.outPutCanSave.emit(true);
    $('.question-' + id).find('li').eq(index).addClass('active').siblings().removeClass('active');
    this.isShowAnalysis = true;
    this.analysis = analysis;
    if (optId) {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'selector': optId,
        'type': 2
      });
    } else {
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'type': 2
      });
    }
  }

  /**
   * 下载PDF文件
   * @param url: String PDF's URL
   */
  downloadPDF(url: string): void {
    this.outPutDownload.emit(url);
  }

  /**
   * 不定项选择题选中
   * @param e: InputObj  事件对象
   * @param id: Number   问题Id
   */
  checkboxSelected(index: number, id: number): void {
    //实战作业day14多选题最多选三个判断逻辑
    if(this.isLastDay){
      if(this.question['options'].filter(item=>item.select).length < 3 || this.question['options'][index].select){
        this.multiSelect(index,id);
      }else{
        this.isShowToast = true;
        this.destext = "请聚焦到3个选项吧！";
        setTimeout(() => {
          this.isShowToast = false;
        }, 2000);
      }
    }else if(this.isFirstDay){//实战作业day1不做改变
      this.multiSelect(index,id);
    }else if(!this.isLastDay && !this.isFirstDay){//智能作业多选题判断逻辑
      this.multiSelect(index,id);
      this.showViewAnswerBtn = true;
      if(this.question['options'].filter(item=>item.select).length>=2){
        this.disableAnswerBtn = false;
      }else{
        this.disableAnswerBtn = true;
        this.isShowAnalysis = false;
      }

    }
  }

  //多选题选中逻辑
  multiSelect(index: number, id: number){
    this.checkBoxData = "";
    this.question['options'][index].select = !this.question['options'][index].select;
      this.question['options'].forEach(item=>{
        if(item.select){
          this.checkBoxData += item.optionId +"|";
        }
      })
      this.outPutCanSave.emit(true);
      // this.checkBoxData = e.target.checked ? this.checkBoxData + $(e.target).val() + '|' : this.checkBoxData.replace($(e.target).val() + '|', '');
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': id,
        'selector': this.checkBoxData,
        'type': 4
      });
      this.isShowAnalysis = false;
  }

  //查看多选题答案解析
  viewAnswer(){
    if(!this.disableAnswerBtn){
      this.showViewAnswerBtn = false;
      this.outGetNextBtn.emit(true);
      this.judgeMulSelect();
    }
  }

  //查看智能作业多选题解析
  judgeMulSelect(){
    this.isShowAnalysis = true;
    this.analysis = this.question['options'].filter(item => (this.multipleAnswers == this.checkBoxData) ? item.correct == 1 : item.correct == 0)[0].analysis;
  }

  /**
   * 触发文件上传
   */
  startUpload():any{
    console.log(this.uploadList);
    if(this.uploadDisabled){
      return false;
    }else{
      $('#upload_input').click();
    }
  }

  /**
   * 文件上传
   * @param e: input[type='file'] 上传input对象
   * @param id: number  问题Id
   */
  uploadFile(e:any,id:number):void{
    let formData = new FormData();
    formData.append('file', $(e.target)[0].files[0]);
    this.outPutFileLoad.emit({'files':formData,'id':id,'el':e.target});
    $(e.target).attr('type','text');
  }

  /**
   * 上传文件删除
   * @param index: Number  上传文件的下标
   * @param id: Number      题目Id
   */
  deleteFile(index:number,id:number):void{
    window.event.cancelBubble = true;
    this.outPutDelFile.emit({'index':index,'id':id});
  }

  expend(relationId: number, id: number) {
    let arrow = $('#arrow-' + relationId + '-' + id), body = $('.answer-' + relationId + '-' + id);
    if (arrow.hasClass('rotateX180')) {
      arrow.removeClass('rotateX180');
      body.addClass('height0');
    } else {
      arrow.addClass('rotateX180');
      body.removeClass('height0');
    }
  }


  /**
   * 获取文本组件传递过来的数据
   * @param event: Object 文本框数据对象
   */
  getTextareaComponentValue(event): any {
    this.outPutCanSave.emit(true);
    if (event['type'] === 3 || event['type'] === 6 || this.question['type'] === 8) {
      this.stepGroup[event['index']][0] = this.stepGroup[event['index']][0] ? this.stepGroup[event['index']][0] : '';
      this.stepGroup[event['index']][1] = event['content'] ? event['content'] : '';
    }

    if(event['type'] === 3 || event['type'] === 6 || this.question['type'] === 8){
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': event['questionId'],
        'tableData': this.stepGroup,
        'type': event['type'],
        'wordOverrun':event['wordOverrun']
      });
    }else{
      this.outPutData.emit({
        'constituteId': this.lpmapcId,
        'questionId': event['questionId'],
        'selector': event['content'],
        'type': event['type'],
        'wordOverrun':event['wordOverrun']
      });
    }
  }
  //复制链接
  copyUrl(){
    if(window.navigator){
      (window.navigator as any).clipboard.writeText( window.location.hostname === 'm.transtalent.cn'? "https://m.transtalent.cn/pc/#/?actualwork=true" :"https://m-uat.transtalent.cn/pc/#/?actualwork=true").then(r=>{
        this.isShowToast = true;
        this.toastTip = "square";
        this.destext = "复制成功";
        setTimeout(() => {
          this.isShowToast = false;
        }, 1500);
      })
    }
  }

  inputFocus(event,i){
    const exerciseItemWrap = document.getElementById("exercise-item-wrap-active");
    let answerStepWrap = document.getElementById(`answer-step-wrap-${i}`);
    if(i == 0) exerciseItemWrap.scrollTop = answerStepWrap.offsetTop;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work-item/item.component.ts